import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export default [
  {
    gridXs: 6,
    stateKey: 'name',
    label: i18n.t('GROUP_KEY'),
    validateOnChange: true,
  },
  {
    gridXs: 6,
    stateKey: 'license_limit',
    label: i18n.t('BULK_CLIENTS.LICENSES_QUANTITY_KEY'),
    validateOnChange: true,
  },
] as GenericFormItem[];
